// extracted by mini-css-extract-plugin
export default {"mainInfo_mainBlock":"MainOrderInfo_mainInfo_mainBlock__xVZw6","mainBlock_row":"MainOrderInfo_mainBlock_row__viG2l","w_100":"MainOrderInfo_w_100__OWUa6"};